import _ from 'lodash'
import { PageData, PageDefinition } from '@wix/thunderbolt-becky-types'

export const addUrlProtocols = (url: string): string => {
	const protocols = ['https://', 'http://', '//']
	const hasProtocol = _.some(protocols, _.includes.bind(null, url))
	return hasProtocol ? url : _.last(protocols) + url
}

const getPageDataParentId = (parentId: PageData | string | undefined) =>
	(parentId as PageData)?.id || (parentId as string)

export const mapPageIdToRoute = (pageDataItems: Record<string, PageDefinition['data']>) =>
	Object.values(pageDataItems).reduce((pageIdToRouteAcc: { [pageId: string]: string }, pageData) => {
		if (!pageIdToRouteAcc[pageData.id]) {
			let currPageData = pageData
			const pageIdsToResolveQueue: Array<string> = []

			while (currPageData) {
				pageIdsToResolveQueue.push(currPageData.id)
				currPageData = pageDataItems[getPageDataParentId(currPageData.parentPageId)]
			}

			while (pageIdsToResolveQueue.length) {
				const pageId = pageIdsToResolveQueue.pop() as string
				const { parentPageId, pageUriSEO } = pageDataItems[pageId]
				pageIdToRouteAcc[pageId] = [pageIdToRouteAcc[getPageDataParentId(parentPageId)], pageUriSEO]
					.filter((x) => x)
					.join('/')
			}
		}

		return pageIdToRouteAcc
	}, {})
